import React, { useState } from 'react';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import ExpertSection from '../ExpertSection';
import { PageContainer, PageHero, PageTitle, PageSubtitle } from './MeetTheTeamElements';
import { HELI, SAJUD, TEJAS } from './teamData';

const MeetTheTeam = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PageContainer>
        <PageHero>
          <PageTitle>Meet the Team</PageTitle>
          <PageSubtitle>
            The people behind Wiry, The experts who help brands grow and connect with their audiences.
          </PageSubtitle>
        </PageHero>
        <ExpertSection {...SAJUD} />
        <ExpertSection {...HELI} />
        <ExpertSection {...TEJAS} />
      </PageContainer>
      <Footer />
    </>
  );
};

export default MeetTheTeam;
